import lineSliceAlong from '@turf/line-slice-along';
import { lineString } from '@turf/helpers';
import { KeyValue } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { PathService } from 'src/app/services/path.service';
import {
  ActionEnum,
  ComplementInformationEnum,
  ComplementInformationSignEnum,
  SignalingTypeEnum,
  VerticalSignalizationTypeEnum,
  WarrantyStatusEnum,
} from 'src/enumerators';
import {
  DeviceSignaling,
  HorizontalSignaling,
  HorizontalSignalingRetroreflectionMeasurement,
  Path,
  PathMarker,
  TrafficSignRetroreflection,
  VerticalSignaling,
  VerticalTrafficSignaling,
} from 'src/models';
import { MapGoogleService } from 'src/app/services/map-google.service';
import { MapService } from 'src/app/services/map.service';
@Component({
  selector: 'app-sidebar-path',
  templateUrl: './sidebar-path.component.html',
  styleUrls: [
    './sidebar-path.component.css',
    '../sidebar-map.component.css',
    '../../../../map-page/map-page.component.css',
  ],
})
export class SidebarPathComponent implements OnInit, OnChanges, OnDestroy {
  currentPath: Path;

  selectedPaths: Map<string, number> = new Map();
  pathsList: Array<Path> = [];

  overflowCounter = 0;

  startEndList = [];
  startsAt = 0;
  endsAt = 0;

  totalCost = 0;
  pathCost = 0;

  verticalSigns: Array<VerticalTrafficSignaling> = [];
  horizontalSigns: Array<HorizontalSignaling> = [];
  deviceSigns: Array<DeviceSignaling> = [];

  highlightPath: google.maps.Polyline

  signsListSize: Set<string> = new Set();

  verticalSignalizationType = VerticalSignalizationTypeEnum;
  complementInformationTypeEnum = ComplementInformationEnum;
  signTypeEnum = SignalingTypeEnum;
  signType = '';
  warrantyTypeEnum = WarrantyStatusEnum;
  warrantyType = '';
  retroreflection = ActionEnum.Retroreflection;
  removeOption = false; // Um booleano para controlar quando troca o principal por meio de remoção

  lastSelected = '';

  @Input() sidebarIdSelected = '';
  @Input() kilometerSelected = 0;
  @Input() retroMeasurementList: Array<HorizontalSignalingRetroreflectionMeasurement> = [];
  @Input() retroMeasurementTrafficList: Array<TrafficSignRetroreflection> = [];
  @Input() googleMap: google.maps.Map;

  @Output() changeIdEmitter = new EventEmitter<string>(); // Emite os valores para o componente pai;

  constructor(
    private _pathService: PathService,
    private _router: Router,
    private _mapGoogleService: MapGoogleService,
    private _mapService: MapService,
  ) { }

  changeIdSelected(id) {
    this.sidebarIdSelected = id;
    this.changeIdEmitter.emit(id);
    if (id == '') {
      if (this.highlightPath) {
        this.highlightPath.setMap(null); // Remove do Google Maps
        this.highlightPath = undefined;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes?.sidebarIdSelected &&
      (changes.sidebarIdSelected.currentValue === '' || changes.sidebarIdSelected.currentValue === '-')) {

      if (this.highlightPath) {
        this.highlightPath.setMap(null);
        this.highlightPath = undefined;
      }

      this.currentPath = undefined;
      this.selectedPaths = new Map();
      this.startEndList = [];
      this.signsListSize = new Set();

      return; // não chama getPathId
    }

    if (
      changes?.sidebarIdSelected?.currentValue != changes?.sidebarIdSelected?.previousValue ||
      !changes?.kilometerSelected ||
      !changes?.kilometerSelected?.currentValue
    ) {
      this.getPathId();
      this.lastSelected = changes?.sidebarIdSelected?.currentValue;
    }

    if (
      !changes?.sidebarIdSelected &&
      changes?.kilometerSelected.currentValue != changes?.kilometerSelected.previousValue
    ) {
      this.startsAt = this.kilometerSelected;
      this.endsAt = this.kilometerSelected + 1;
      this.setStartEndList(this.currentPath.id);
    }
  }


  ngOnInit(): void {
    this.getPathId();
    this.getAllPaths();
    this.lastSelected = this.sidebarIdSelected;
  }

  ngOnDestroy(): void {
    if (this.highlightPath) {
      this.highlightPath.setMap(null);
      this.highlightPath = undefined;
    }
  }

  closeSideBar() {
    this.changeIdSelected('');

    this._mapGoogleService.toggleSideBar(false);
    this._mapService.openSideBar(false);

    if (this.highlightPath) {
      this.highlightPath.setMap(null);
      this.highlightPath = undefined;
    }
  }

  setStartEndList(pathId) {
    this.startEndList = [];
    this.signsListSize = new Set();

    for (let i = 0; i <= this.currentPath?.numberOfMarkers; i++) {
      let start = this.currentPath.startsAt + i;
      this.startEndList.push(start);
    }

    if (this.selectedPaths.size > 0) {
      this.startEndChange(pathId);
    }
  }

  startEndChange(pathId) {
    this.pathCost = 0;
    this.selectedPaths[pathId] = 0;

    if (this.selectedPaths.size == 1) this.totalCost = 0;

    this.verticalSigns.forEach((traffic) => {
      if (this.selectedPaths.size == 1 && traffic.startsAt >= this.startsAt && traffic.startsAt <= this.endsAt) {
        this.pathCost += traffic.cost;
      }
      if (pathId == traffic.pathId) this.selectedPaths[pathId] += traffic.cost;
    });

    this.horizontalSigns.forEach((horizontal) => {
      if (
        (this.selectedPaths.size == 1 && horizontal.startsAt >= this.startsAt && horizontal.startsAt <= this.endsAt) ||
        (horizontal.endsAt >= this.startsAt && horizontal.endsAt <= this.endsAt)
      ) {
        this.pathCost += horizontal.cost;
      }
      if (pathId == horizontal.pathId) this.selectedPaths[pathId] += horizontal.cost;
    });

    this.deviceSigns.forEach((device) => {
      if (
        (this.selectedPaths.size == 1 && device.startsAt >= this.startsAt && device.startsAt <= this.endsAt) ||
        (device.endsAt >= this.startsAt && device.endsAt <= this.endsAt)
      ) {
        this.pathCost += device.cost;
      }
      if (pathId == device.pathId) this.selectedPaths[pathId] += device.cost;
    });

    this.totalCost += this.selectedPaths[pathId];

    let startsAtIndex = this.startsAt - this.currentPath.startsAt;
    let endsAtIndex = this.endsAt - this.currentPath.startsAt;
    if (this.endsAt - this.currentPath.startsAt == this.currentPath.startsAt + this.currentPath.numberOfMarkers)
      endsAtIndex += 1;
    this.setPathHighlight(this.currentPath, startsAtIndex, endsAtIndex);

  }

  getPathId(endsAtPlus = false) {
    this.signsListSize = new Set();
    this.selectedPaths = new Map();
    this.startsAt = this.kilometerSelected;
    this.endsAt = this.kilometerSelected + 1;

    if (this.sidebarIdSelected != '-') {

      this._pathService.getPathById(this.sidebarIdSelected).subscribe((res: Path) => {
        this.currentPath = res;
        this.selectedPaths.set(res.id, 0);
        if (endsAtPlus || this.removeOption || !this.kilometerSelected) {
          // Caso selecione o valor inicial com o sidebar aberto
          this.startsAt = res.startsAt;
          this.endsAt = this.startsAt + res.numberOfMarkers - 1;
          this.removeOption = false;
          this.setPathHighlight(this.currentPath, 0, (this.endsAt - this.startsAt + 1))
        }

        this.getAllSigns(res.id);
      });
    }
  }

  getAllPaths() {
    this._pathService.getPaths(['id', 'name']).subscribe((res: Array<Path>) => {
      this.pathsList = res;
      this._pathService.getMarkers().subscribe(
        (markers: PathMarker[]) => {
          this.pathsList.forEach(path => {
            markers.forEach(marker => {
              if (marker.pathId == path.id) path.markers.push()
            })
          })
        }
      )
    });
  }

  setPathHighlight(path: any, startsAt: number, endsAt: number) {
    // 1. LIMPEZA: Remove o destaque anterior do mapa se existir
    if (this.highlightPath) {
      this.highlightPath.setMap(null); // Remove do Google Maps
      this.highlightPath = undefined;
      console.log(this.highlightPath)
    }

    let finalCoordinates = [];

    // Verificação se é o trajeto completo (Otimização para não usar Turf sem necessidade)
    // Ajuste a lógica matemática do 'full path' conforme sua regra de negócio exata
    const isFullPath = (path.startsAt == startsAt && (path.startsAt + path.numberOfMarkers - 1 - path.startsAt) == endsAt);
    console.log(isFullPath)
    if (isFullPath) {
      // Se for o trajeto todo, usa os vértices originais
      finalCoordinates = path.vertices;
    } else {
      // 2. PREPARAÇÃO TURF: Converte {lat, lng} para [lng, lat]
      let lngLatCoordinates = path.vertices.map(v => [v.lng, v.lat]);

      // 3. CORTE: Cria a LineString e fatia
      const polylineString = lineString(lngLatCoordinates);
      const sliceLine = lineSliceAlong(polylineString, startsAt, endsAt, { units: 'kilometers' });

      // 4. REVERSÃO: Converte de volta de [lng, lat] para {lat, lng} do Google Maps
      finalCoordinates = sliceLine.geometry.coordinates.map(coord => ({
        lat: coord[1],
        lng: coord[0]
      }));
    }
    console.log(finalCoordinates)
    // 5. CRIAÇÃO: Cria a nova Polyline usando seu serviço
    // Nota: Passamos 'true' para highLight. O serviço deve retornar a polyline com map: null
    this.highlightPath = this._mapGoogleService.addPathLayer(
      finalCoordinates,
      true // highlight ativo
    );
    console.log(this.highlightPath)
    // 6. RENDERIZAÇÃO: Adiciona explicitamente ao mapa
    // Como é um destaque único, não precisamos jogar no array de activeLayers,
    // basta controlar a variável this.highlightPath
    console.log(this.googleMap);

    this.highlightPath.setMap(this.googleMap);
  }

  getAllSigns(pathId) {
    if (this.selectedPaths.size == 1) {
      this.verticalSigns = [];
      this.horizontalSigns = [];
      this.deviceSigns = [];
    }

    this._pathService.getVerticalPath(pathId).subscribe((verticals: Array<VerticalSignaling>) => {
      verticals.forEach((vertical) => {
        vertical.trafficSigns.forEach((trafficSign, index) => {
          vertical['useTraffic'] = index;
          const indexSign = this.verticalSigns.findIndex((sign) => sign.id == trafficSign.id);
          if (indexSign == -1) {
            const sign = new VerticalTrafficSignaling(vertical);
            this.verticalSigns.push(sign);
          }
        });
      });

      this._pathService.getHorizontalPath(pathId).subscribe((res: Array<HorizontalSignaling>) => {
        res.forEach((horizontal) => {
          const indexSign = this.horizontalSigns.findIndex((sign) => sign.id == horizontal.id);
          if (indexSign == -1) this.horizontalSigns.push(horizontal);
        });

        this._pathService.getDevicePath(pathId).subscribe((res: Array<DeviceSignaling>) => {
          res.forEach((device) => {
            const indexSign = this.deviceSigns.findIndex((sign) => sign.id == device.id);
            if (indexSign == -1) this.deviceSigns.push(device);
          });
          this.setStartEndList(pathId);
        });
      });
    });
  }

  // Adiciona o item selecionado, a tag nova, na lista de selecionados;
  addOptionFilter(valueId) {
    this.selectedPaths.set(valueId, 0);
    this.signsListSize = new Set();

    if (this.selectedPaths.size == 1) {
      this.sidebarIdSelected = valueId;
      this.getPathId(true);
    } else {
      this.getAllSigns(valueId);
    }
    this.lastSelected = valueId;

    setTimeout(() => {
      this.calcLenSelect();
    }, 200);
  }

  // Remove o teim selecionado, a tag some, na lista de selecionados;
  removeOptionFilter(valueId) {
    this.selectedPaths.delete(valueId);
    this.lastSelected = '';
    this.signsListSize = new Set();

    this.verticalSigns = this.verticalSigns.filter(vertical => vertical.pathId != valueId);
    this.horizontalSigns = this.horizontalSigns.filter(horizontal => horizontal.pathId != valueId);
    this.deviceSigns = this.deviceSigns.filter(device => device.pathId != valueId);

    if (this.selectedPaths.size == 1) {
      for (let key of this.selectedPaths.keys()) {
        this.currentPath = this.pathsList.find((path) => path.id == key);
        this.kilometerSelected = this.currentPath.startsAt;
        this.startsAt = this.currentPath.startsAt;
        this.endsAt = this.currentPath.startsAt + this.currentPath.numberOfMarkers - 1;
        this.removeOption = true;
        this.changeIdSelected(key);
      }
    } else if (this.selectedPaths.size == 0) {
      this.changeIdSelected('-');
    }

    if (this.highlightPath) {
      this.highlightPath.setMap(null); // Remove do Google Maps
      this.highlightPath = undefined;
    }

    setTimeout(() => {
      this.calcLenSelect();
    }, 200);
  }

  // Calcula o tamanho do select para colocar o '+ N' ao final e esconder os que passam do tamanho
  calcLenSelect() {
    let sum = 0;
    let countPlus = 0;
    const selected = document.getElementById('path');
    const tagSelected = document.getElementById('tags-selected');

    if (tagSelected) {
      if (tagSelected.nodeName == 'DIV') {
        tagSelected.childNodes.forEach((child) => {
          if (child.nodeName == 'DIV' && child.textContent) {
            (child as HTMLElement).hidden = false;
            if (sum + (child as HTMLElement).offsetWidth + 16 < selected.offsetWidth * 0.8 && countPlus == 0) {
              sum = sum + (child as HTMLElement).offsetWidth + 16;
            } else {
              countPlus += 1;
              (child as HTMLElement).hidden = true;
            }
          }
        });
      }
    }
    this.overflowCounter = countPlus;
  }

  // Verifica se na lista de objetos tem algum objeto com certo ID e retorna o name dele;
  isValueKeyId(value, list): string {
    let name = '';
    list.some((element) => {
      if (element.id == value) {
        name = element.name;
      }
    });
    return name;
  }

  // Retorna qual é o tipo da informação complementar sabendo qual é o tipo da placa WARNING/REGULATION
  complementType(sign): ComplementInformationSignEnum {
    if (sign.complementInformationType == ComplementInformationEnum.Additional) {
      if (sign.verticalType == VerticalSignalizationTypeEnum.Warning) {
        return ComplementInformationSignEnum.AdditionalWarning;
      } else {
        return ComplementInformationSignEnum.AdditionalRegulation;
      }
    } else {
      if (sign.verticalType == VerticalSignalizationTypeEnum.Warning) {
        return ComplementInformationSignEnum.IncorporatedWarning;
      } else {
        return ComplementInformationSignEnum.IncorporatedRegulation;
      }
    }
  }

  getPathName(pathId): string {
    return this.pathsList.find(path => path.id == pathId).name || '-';
  }

  // Preserva ordem do ngFor | keyvalue
  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  };

  textSelect(type, value): string {
    let text = '';
    if (type == 'sign') {
      if (value == SignalingTypeEnum.Device) text = 'Apenas os dispositivos';
      else if (value == SignalingTypeEnum.Horizontal) text = 'Apenas as horizontais';
      else text = 'Apenas as verticais';
    } else {
      if (value == WarrantyStatusEnum.EndWarranty) text = 'Fim da garantia';
      else if (value == WarrantyStatusEnum.UnderWarranty) text = 'Garantia ativa';
      else text = 'Garantia expirada';
    }
    return text;
  }

  warrantyTypeToNumber(warrantyType): number {
    let number;

    if (warrantyType == WarrantyStatusEnum.UnderWarranty) number = 1;
    else if (warrantyType == WarrantyStatusEnum.EndWarranty) number = 2;
    else if (warrantyType == WarrantyStatusEnum.ExpiredWarranty) number = 3;

    return number;
  }

  showSign(sign): boolean {
    let show = true;

    if (!(sign.type == this.signType || !this.signType)) show = false;

    if (this.warrantyType == 'retro') {
      if (sign.type == SignalingTypeEnum.Vertical) {
        const index = this.retroMeasurementTrafficList.findIndex(
          (retroTraffic) => retroTraffic.trafficSignId == sign.id,
        );
        if (index == -1) {
          show = false;
        }
      } else if (sign.type == SignalingTypeEnum.Horizontal) {
        const index = this.retroMeasurementList.findIndex(
          (retroTraffic) => retroTraffic.horizontalSignalingId == sign.id,
        );
        if (index == -1) {
          show = false;
        }
      } else {
        show = false;
      }
    } else if (!(sign.active == this.warrantyTypeToNumber(this.warrantyType) || !this.warrantyType)) show = false;

    if (sign.type == SignalingTypeEnum.Vertical) {
      if (this.selectedPaths.size == 1) {
        if (!(sign.startsAt >= this.startsAt && sign.startsAt <= this.endsAt)) show = false;
      }
    } else {
      if (this.selectedPaths.size == 1) {
        if (
          !(
            (sign.startsAt >= this.startsAt && sign.startsAt <= this.endsAt) ||
            (sign.endsAt >= this.startsAt && sign.endsAt <= this.endsAt)
          )
        )
          show = false;
      }
    }

    if (show) {
      if (!this.signsListSize.has(sign.id)) {
        this.signsListSize.add(sign.id);
      }
    } else {
      if (this.signsListSize.has(sign.id)) {
        this.signsListSize.delete(sign.id);
      }
    }

    return show;
  }

  retroAlertExist(signId, type) {
    if (type == SignalingTypeEnum.Vertical) {
      if (this.retroMeasurementTrafficList.findIndex((sign) => sign.trafficSignId == signId) != -1) {
        return true;
      }
    } else {
      if (this.retroMeasurementList.findIndex((sign) => sign.horizontalSignalingId == signId) != -1) {
        return true;
      }
    }

    return false;
  }

  // Troca de página para detalhes
  signDetailRouting(element: any) {
    let type;
    let id;
    if (element.type == SignalingTypeEnum.Vertical || element.groupId) {
      type = element.order;
      id = element.groupId;
    } else {
      type = element.type;
      id = element.id;
    }
    this._router.navigate([`/catalog/detail/${id}`], { queryParams: { type } });
  }

}
